import type { App } from "vue";

export function registerFilters(app: App) {
	app.config.globalProperties.$filters = {
		format2decimals(value: number): string {
			return value.toFixed(2);
		},
		formatInteger(value: number): number {
			return Math.round(value);
		},
	};
}
